import { render, staticRenderFns } from "./PageWarning.vue?vue&type=template&id=39d2b093&"
import script from "./PageWarning.vue?vue&type=script&lang=js&"
export * from "./PageWarning.vue?vue&type=script&lang=js&"
import style0 from "./PageWarning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports